import styled, { css, keyframes } from "styled-components";
import { TooltipContent } from "../../../base/others/tooltip/styled.js";
import { RadioButtonLabel } from "../../../forms/inputs/radio-button-group/components/radio-button/styled.js";
import { Panel } from "../../../forms/others/input-panel/views/desktop/styled.js";
import { ScrollHorizontalList } from "../../../structures/others/scroll-horizontal/styled.js";
import { FlexColumnMixin, FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../styles/common/mixins/logical.styled.js";
import searcherThemes from "./themes/index.js";
export const SearcherWrapper = styled.div.withConfig({
    displayName: "styled__SearcherWrapper",
    componentId: "sc-95a8736d-0"
})`
	--searcher-wrapper-padding: 16px;
	background-color: ${({ theme  })=>theme.colors.secondary.base};
	padding: var(--searcher-wrapper-padding);
	border-radius: ${({ theme  })=>theme.border.radius.rounded};

	& & {
		margin: -16px;
	}

	form {
		width: 100%;
	}

	${({ theme  })=>searcherThemes[theme.id]?.SearcherWrapper?.()}
`;
export const MobileSearcherWrapper = styled(SearcherWrapper).withConfig({
    displayName: "styled__MobileSearcherWrapper",
    componentId: "sc-95a8736d-1"
})`
	background-color: ${({ theme  })=>theme.colors.primary.base};
	border-radius: 0;

	${({ theme  })=>searcherThemes[theme.id]?.MobileSearcherWrapper?.()}
`;
export const SearcherContent = styled.fieldset.withConfig({
    displayName: "styled__SearcherContent",
    componentId: "sc-95a8736d-2"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: 16px;
	margin-bottom: 0;
	min-inline-size: auto;
	width: 100%;
`;
export const SearcherDivision = styled.div.withConfig({
    displayName: "styled__SearcherDivision",
    componentId: "sc-95a8736d-3"
})`
	${({ $justify ='flex-start'  })=>FlexMixin({
        justify: $justify,
        wrap: true
    })}
	--division-gap: 16px;
	gap: var(--division-gap);
`;
export const SearcherTop = styled(SearcherDivision).withConfig({
    displayName: "styled__SearcherTop",
    componentId: "sc-95a8736d-4"
})`
	overflow-x: auto;
	width: ${({ $width  })=>$width ? `calc(${$width}px - (var(--searcher-wrapper-padding) * 2))` : '100%'};
	max-width: calc(100vw - (var(--searcher-wrapper-padding) * 2));

	${ScrollHorizontalList} {
		padding: 0;
	}

	${RadioButtonLabel} {
		${({ theme  })=>searcherThemes[theme.id]?.RadioButtonLabel?.()}
	}
`;
export const searcherItemVariants = {
    smaller: '10%',
    small: '14%',
    medium: '16%',
    large: '18%',
    larger: '20%',
    largest: '28%',
    adaptive: 'auto'
};
export const SearcherItem = styled.div.withConfig({
    displayName: "styled__SearcherItem",
    componentId: "sc-95a8736d-5"
})`
	--searcher-item-xl-basis: ${({ $variant ='medium'  })=>searcherItemVariants[$variant]};
	${({ $order  })=>$order ? `order: ${$order};` : ''}

	${({ $variant ='medium'  })=>searcherItemVariants[$variant] === 'auto' ? 'flex-basis: auto;' : `
				flex-basis: 100%;
				max-width: 100%;
			`};
	flex-shrink: 1;

	${({ theme  })=>theme.media.up('md')} {
		${({ $variant ='medium'  })=>searcherItemVariants[$variant] !== 'auto' ? FlexColumnMixin({
        columns: 2,
        gap: 'var(--division-gap)'
    }) : ''};
	}

	${({ theme  })=>theme.media.up('lg')} {
		${({ $variant ='medium'  })=>searcherItemVariants[$variant] !== 'auto' ? FlexColumnMixin({
        columns: 3,
        gap: 'var(--division-gap)'
    }) : ''};
	}

	${({ theme  })=>theme.media.up('xl')} {
		${({ $variant ='medium'  })=>searcherItemVariants[$variant] === 'auto' ? 'flex-basis: auto;' : 'flex-basis: calc(var(--searcher-item-xl-basis) - var(--division-gap));'}
		${({ $grow =false  })=>`flex-grow: ${$grow ? 1 : 0};`}
		max-width: 100%;
	}
`;
export const SearcherItemWithMaxWidth = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemWithMaxWidth",
    componentId: "sc-95a8736d-6"
})`
	${({ theme  })=>theme.media.up('xl')} {
		max-width: var(--searcher-item-xl-basis);
	}
`;
export const SearcherMiddle = styled(SearcherDivision).withConfig({
    displayName: "styled__SearcherMiddle",
    componentId: "sc-95a8736d-7"
})`
	position: relative;

	${({ $isModal =false  })=>$isModal && css`
			display: unset;

			${SearcherItem}:not(.searcher-button) {
				${BorderRadius({
        all: '4px'
    })}
				border: 1px solid ${({ theme  })=>theme.colors.grays.light};
				margin-bottom: 16px;
				max-width: unset;

				${Panel} {
					max-width: calc(100% - 32px);
					width: 390px;
				}
			}

			${TooltipContent} {
				max-width: unset;
				min-width: unset !important;
				width: 390px !important;
			}

			.flatpickr-wrapper {
				position: initial;
				display: initial;
			}

			.searcher-button {
				> div,
				button {
					width: 100%;
					max-width: 100%;
				}
			}
		`}
`;
export const SearcherNumber = styled.span.withConfig({
    displayName: "styled__SearcherNumber",
    componentId: "sc-95a8736d-8"
})`
	color: ${({ theme  })=>theme.colors.primary.light};
	${FontMixin({
    size: 'large',
    height: 'large',
    weight: 'medium'
})}

	${({ theme  })=>searcherThemes[theme.id]?.SearcherNumber?.()}
`;
export const SearcherNumberText = styled.span.withConfig({
    displayName: "styled__SearcherNumberText",
    componentId: "sc-95a8736d-9"
})`
	color: ${({ theme  })=>theme.colors.text.dark};
	${FontMixin({
    size: 'medium',
    height: 'small',
    weight: 'light'
})}

	${({ theme  })=>searcherThemes[theme.id]?.SearcherNumberText?.()}
`;
export const SearcherReset = styled.button.withConfig({
    displayName: "styled__SearcherReset",
    componentId: "sc-95a8736d-10"
})`
	cursor: pointer;
	transition: opacity 0.3s;
	width: 100%;
	text-align: center;
	color: ${({ theme  })=>theme.colors.primary.light};
	margin-top: 4px;
	${FlexMixin({
    justify: 'center',
    align: 'center'
})}
	${FontMixin({
    size: 'smaller',
    height: 'small',
    weight: 'light'
})}
	white-space: nowrap;

	i {
		margin-right: 4px;
		margin-top: 4px;
		${FontMixin({
    size: 'medium',
    height: 'smaller',
    weight: 'light'
})};
	}

	&[disabled] {
		cursor: default;
		opacity: 0.7;
	}

	${({ theme  })=>searcherThemes[theme.id]?.SearcherReset?.()}
`;
export const SearcherTopScrollMobile = styled(SearcherTop).withConfig({
    displayName: "styled__SearcherTopScrollMobile",
    componentId: "sc-95a8736d-11"
})`
	overflow-x: auto;
	width: ${({ $width =0  })=>$width ? `calc(${$width}px - (var(--searcher-wrapper-padding) * 2))` : '100%'};
	max-width: calc(100vw - (var(--searcher-wrapper-padding) * 2));
`;
const loaderAnimation = keyframes`
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
        transform: translate(-50%, -50%) rotate(359deg);
    }
`;
export const SearcherLoader = styled.div.withConfig({
    displayName: "styled__SearcherLoader",
    componentId: "sc-95a8736d-12"
})`
	${FlexMixin({
    align: 'flex-start',
    justify: 'center'
})}
	position: relative;
	min-height: 84px;
	width: 100%;

	&::before {
		content: '';
		border: 3px solid ${({ theme  })=>theme.colors.primary.light};
		border-left: 2px solid ${({ theme  })=>theme.colors.grays.dark};
		border-radius: 100%;
		display: block;
		height: 50px;
		width: 50px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		animation: ${loaderAnimation} 1s linear infinite;
	}
`;

//# sourceMappingURL=styled.js.map